import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {},
  directionHorizontal: {
    flexDirection: 'row',
  },
  directionVertical: {
    flexDirection: 'column',
  },
  alignStart: {
    alignItems: 'flex-start',
  },
  alignCenter: {
    alignItems: 'center',
  },
  alignEnd: {
    alignItems: 'flex-end',
  },
  alignStretch: {
    alignItems: 'stretch',
  },
  crossAlignStart: {
    justifyContent: 'flex-start',
  },
  crossAlignCenter: {
    justifyContent: 'center',
  },
  crossAlignEnd: {
    justifyContent: 'flex-end',
  },
  expand: {
    flex: 1,
  },
});
